export const ALL_STAND_COLUMNS = [
	"H1",
	"V2",
	"H3",
	"HV4",
	"V5",
	"H6",
	"H7",
	"V8",
	"S1",
	"H9",
	"H10",
	"HV11",
	"H12",
	"H13",
	"HV14",
	"H15",
	"HV16",
	"H17",
] as const;

// S1 (Straightener) intentionally omitted from the visible grid.
export const STAND_COLUMNS = [
	"H1",
	"V2",
	"H3",
	"HV4",
	"V5",
	"H6",
	"H7",
	"V8",
	"H9",
	"H10",
	"HV11",
	"H12",
	"H13",
	"HV14",
	"H15",
	"HV16",
	"H17",
] as const;

export type StandColumnName = (typeof ALL_STAND_COLUMNS)[number];

export type StandColumnValue = string | null;

const STAND_TYPE_NAMES: Record<string, string> = {
	H: "Horizontal",
	V: "Vertical",
	HV: "Horizontal/Vertical convertible",
	S: "Straightener",
};

export const getStandTooltip = (standName: StandColumnName): string => {
	const match = /^([HVS]+)(\d+)$/.exec(standName);
	if (!match) return standName;
	const [, prefix, number] = match;
	const type = STAND_TYPE_NAMES[prefix] ?? prefix;
	return `Stand ${number} — ${type}`;
};

export interface BilletProcessRow {
	Id: number;
	Start: string | null;
	End: string | null;
	IsGood: boolean;
	CrewId: string | null;
	Length: number | null;
	BilletWeight: number | null;
	LineSpeed: number | null;
	LineSpeed2: number | null;
	Gap: number | null;
	Gap17: number | null;
	BilletSize: string | null;
	ProductName: string | null;
	StartString: string | null;
	EndString: string | null;
	H1?: StandColumnValue;
	V2?: StandColumnValue;
	H3?: StandColumnValue;
	HV4?: StandColumnValue;
	V5?: StandColumnValue;
	H6?: StandColumnValue;
	H7?: StandColumnValue;
	V8?: StandColumnValue;
	S1?: StandColumnValue;
	H9?: StandColumnValue;
	H10?: StandColumnValue;
	HV11?: StandColumnValue;
	H12?: StandColumnValue;
	H13?: StandColumnValue;
	HV14?: StandColumnValue;
	H15?: StandColumnValue;
	HV16?: StandColumnValue;
	H17?: StandColumnValue;
}

export const BILLET_PROCESS_VARIABLE_NAMES = [
	"RollSet",
	"BottomRoll",
	"TopRoll",
	"PassName",
	"PassPosition",
	"RecipeRFactorMin",
	"RecipeRFactorMax",
	"RecipeRFactorTarget",
	"SetupPassId",
	"RecipePassId",
	"CurrentMin",
	"CurrentMax",
	"CurrentAvg",
	"CurrentStDev",
	"SpeedMin",
	"SpeedMax",
	"SpeedAvg",
	"SpeedStDev",
	"RFactorMin",
	"RFactorMax",
	"RFactorAvg",
	"RollDiameter",
	"RollGroove",
	"LooperHeightMin",
	"LooperHeightMax",
	"LooperHeightAvg",
	"LooperHeightStDev",
	"TensionControl",
	"Selected",
	"Working",
	"LooperControlSelected",
] as const;

export type BilletProcessVariableName =
	(typeof BILLET_PROCESS_VARIABLE_NAMES)[number];

export interface BilletProcessPickerCrew {
	Id: string;
}

export interface BilletProcessPickerProductType {
	Id: number;
	Name: string;
}

export interface BilletProcessPickerProductSize {
	Id: number;
	Name: string;
	ProductTypeId: number;
}

export interface BilletProcessPickerVariableName {
	// SP column is `VariableName`, not `Name`.
	VariableName: string;
}

export interface BilletProcessPickers {
	variableNames: BilletProcessPickerVariableName[];
	crews: BilletProcessPickerCrew[];
	productTypes: BilletProcessPickerProductType[];
	productSizes: BilletProcessPickerProductSize[];
}
